import { render, staticRenderFns } from "./AboutHQ.vue?vue&type=template&id=f140ecbc&scoped=true"
import script from "./AboutHQ.vue?vue&type=script&lang=js"
export * from "./AboutHQ.vue?vue&type=script&lang=js"
import style0 from "./AboutHQ.vue?vue&type=style&index=0&id=f140ecbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140ecbc",
  null
  
)

export default component.exports